import axios from 'axios'

class RequestService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Alan Aguilar
  * @description Search a document by PDF
  * @updatedDate 11-11-2021
  * @param {Object} documentFiles
  * @param {String} token
  * @returns {Object}
  * @memberof RequestService
  */
  async searchDocumentPdf(documentFiles, token) {
    let response = await axios.post(`${this.apiUrl}/request-search-document`, documentFiles, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Alan Aguilar
  * @description Generate the validation report by PDF
  * @updatedDate 11-11-2021
  * @param {Object} documentFiles
  * @param {String} token
  * @returns {Object}
  * @memberof RequestService
  */
  async createRequestValidationReport(documentFiles, token) {
    let response = await axios.post(`${this.apiUrl}/request-validate-documents`, documentFiles, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Alan Aguilar
  * @description Send email validation report o user
  * @updatedDate 11-11-2021
  * @param {String} requestId
  * @param {String} token
  * @returns {Object}
  * @memberof RequestService
  */
  async sendEmailRequestValidationReport(requestId, token) {
    let response = await axios.post(`${this.apiUrl}/request-send-report`, { requestId }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }
}

export { RequestService as default }